<ion-header class="ion-no-border" id="video-header" [translucent]="true">
  <ion-toolbar *ngIf="ready">
    <ion-buttons *ngIf="!ended" slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <div class="flexv" style="line-height: 1.1rem; padding-left: 16px;">
      <div class="training-title">{{t.title}}</div>
      <div class="training-desc">{{t.description}}</div>
    </div>
    <div *ngIf="t.race_active" class="timer" slot="end">
      {{qelapsed}}
    </div>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="ready">
  <div class="flexv h-full p-4">

    <div class="stepper-container">
      <div *ngIf="!ended" class="flexv" style="width: 100%;">
        <p-panel [ngStyle]="{'width':'100%'}" ngClass="!text-center !fade-in !w-full" [header]="'DOMANDA '+(qindex+1)+' di '+t.numQuest">
          <div class="qtext mb-6">{{q.qtext}}</div>
          <div *ngFor="let r of q.responses">
            <ion-button expand="block" class="mb-4 ion-text-wrap" (click)="setUserResponse($event, qindex, q.qid!,r.rid!)" [color]="getSeverity(r.rid)">
              <div style="font-size: 1.2rem;">{{r.rtext}}</div>
              <i slot="end" *ngIf="isDev() && r.correct" class="pi pi-check ml-2"></i>
            </ion-button>
          </div>
        </p-panel>
      </div>
      <div *ngIf="ended && user">
        <app-confetti [user]="user" [t]="t"></app-confetti>
      </div>
    </div>



  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar class="tnav" *ngIf="ready && !ended">
    <ion-button slot="start" fill="clear" *ngIf="hasPrev(qindex)" color="dark" (click)="prevQuest()">
      <ion-label>Precedente</ion-label>
      <i class="pi pi-arrow-left mr-2" slot="start"></i>
    </ion-button>
    <ion-button slot="end" color="dark" fill="clear" class="ml-auto" [disabled]="nextReady(qindex)" (click)="nextQuest()">
      <ion-label>Prossima</ion-label>
      <i class="pi pi-arrow-right ml-2" slot="end"></i>
    </ion-button>
  </ion-toolbar>
</ion-footer>